import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const { isAdmin, authLoading } = useAuth();

  if (authLoading) {
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <div className='spinner spinner-dark'></div>
      </div>
    );
  }

  if (!token || !isAdmin) return <Navigate to='/dashboard' replace />;
  return children;
};

export default AdminRoute;
